import { useQuery } from "@tanstack/react-query"
import { getFeatureFlags } from "../api/feature-flags-api"

export const FEATURE_FLAGS_QUERY_KEY = ["feature-flags"] as const

/**
 * Fetches every waffle flag/switch/sample's resolved state for the
 * current user. Cached for 5 minutes — flags rarely change at runtime,
 * and we don't want to refetch on every navigation. To force-refresh
 * after an admin toggles a flag, invalidate `FEATURE_FLAGS_QUERY_KEY`.
 *
 * Falls back to an empty record on error so the UI degrades to "all
 * flags off" rather than crashing.
 */
export function useFeatureFlags(opts: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: FEATURE_FLAGS_QUERY_KEY,
    queryFn: getFeatureFlags,
    enabled: opts.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  })
}
